export class QuoteGroupView {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.dealerGroupId = item.dealerGroupId;
      this.dealerGroup = item.dealerGroup;
      this.dealerContactId = item.dealerContactId;
      this.dealerContact = item.dealerContact;
      this.dateCreated = item.dateCreated;
      this.createdByUserName = item.createdByUserName;
      this.dealerBranches = item.dealerBranches;
      this.totalAmount = item.totalAmount;
      return;
    }
    this.id = null;
    this.name = '';
    this.dealerGroupId = '';
    this.dealerGroup = '';
    this.dealerContactId = '';
    this.dealerContact = '';
    this.dateCreated = '';
    this.createdByUserName = '';
    this.dealerBranches = [];
    this.totalAmount = '';
  }
}
